import Alpine from 'alpinejs';

import collapsePlugin from '@alpinejs/collapse';
import focusPlugin from '@alpinejs/focus';
import intersectPlugin from '@alpinejs/intersect';
import maskPlugin from '@alpinejs/mask';
import persistPlugin from '@alpinejs/persist';

import accordion from './mixins/accordion';
import lead from './mixins/lead';
import carousel from './mixins/carousel';
import collapse from './mixins/collapse';
import dropdown from './mixins/dropdown';
import expandable from './mixins/expandable';
import indicator from './mixins/indicator';
import phone from './mixins/phone';
import tabs from './mixins/tabs';
import contact from './stores/contact';

window.Alpine = Alpine;

Alpine.plugin(collapsePlugin);
Alpine.plugin(focusPlugin);
Alpine.plugin(intersectPlugin);
Alpine.plugin(maskPlugin);
Alpine.plugin(persistPlugin);

Alpine.store('contact', contact);

Alpine.data('lead', lead);

Alpine.data('accordion', accordion);
Alpine.data('carousel', carousel);
Alpine.data('collapse', collapse);
Alpine.data('dropdown', dropdown);
Alpine.data('expandable', expandable);
Alpine.data('indicator', indicator);
Alpine.data('phone', phone);
Alpine.data('tabs', tabs);

Alpine.start();
